// LivestreamDetailOnlineHeader.js
import { connect } from 'react-redux';

import LivestreamDetailOnlineHeader from '../component/LivestreamDetailOnlineHeader.jsx';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getFormattedLiveStreamViewers from '../selector/getFormattedLiveStreamViewers.js';

import toggleModal from '../action/toggleModal.js';

import {
  ExclusivePrivateStatus,
  PRESET_PREVIEW,
} from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );

  const isExclusivePrivatePerforming =
    ExclusivePrivateStatus.PERFORMING === exclusivePrivateStatus;
  const hasStreamToken = !!(
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'byteplusToken'
    ) ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken')
  );
  const canWatchStream = streamStatus === PRESET_PREVIEW || hasStreamToken;
  const isExclusivePrivateOngoing = [
    ExclusivePrivateStatus.PERFORMING,
    ExclusivePrivateStatus.PREPARING,
  ].includes(exclusivePrivateStatus);

  return {
    needStreamTokenForExclusivePrivatePerforming:
      isExclusivePrivatePerforming && !hasStreamToken,
    canWatchStream,
    isExclusivePrivateOngoing,
    viewers: getFormattedLiveStreamViewers(state, streamId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: data => dispatch(toggleModal(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamDetailOnlineHeader);
